import $ from 'jquery';

export default {
  // 加载内容：js，css，style
  loadFile(opt) {
    let options = $.extend(
      {
        type: 'js',
        url: '',
        loadCallback: function () {
          // console.log('加载完毕回调');
        },
      },
      opt,
    );
    let file;
    if (options.type == 'js') {
      file = document.createElement('script');
      file.src = options.url;
    } else if (options.type == 'css') {
      file = document.createElement('link');
      file.rel = 'stylesheet';
      file.href = options.url;
    } else if (options.type == 'style') {
      file = document.createElement('style');
      file.rel = 'stylesheet';
      file.innerHTML = options.style;
    }
    document.getElementsByTagName('head')[0].appendChild(file);
    file.onload = function () {
      options.loadCallback();
    };
  },

  // 节流：是将多次执行变为每隔一段时间执行。
  throttle(fn, interval = 250) {
    let lastTime = 0;
    return function (...args) {
      let now = Date.now();
      if (now - lastTime >= interval) {
        lastTime = now;
        fn.apply(this, args);
      }
    };
  },

  // 防抖：是将多次执行变为最后一次执行
  debounce(fn, delay = 250) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  },

  //检查css支持
  cssSupport(attr, value, needAddClass) {
    var element = document.createElement('div');
    var notSupport = function () {
      console.warn('css不支持' + attr + ':' + value);
      if (needAddClass) {
        let $html = document.querySelector('html');
        $html.classList.add('no-' + value);
      }
      return false;
    };
    if (attr in element.style) {
      element.style[attr] = value;
      if (element.style[attr] != value) {
        notSupport();
      } else {
        return true;
      }
    } else {
      notSupport();
    }
  },

  //获取css变量
  getCssVar(cssVar, el) {
    el = el || document.documentElement;
    let cssVarVal = getComputedStyle(el).getPropertyValue(cssVar);
    if (cssVarVal) {
      return cssVarVal;
    }
    return false;
  },

  //设置css变量
  setCssVar(el, cssVar) {
    if (!el || !cssVar) return;
    for (const [k, v] of Object.entries(cssVar)) {
      el.style.setProperty(`--${k}`, v);
    }
  },

  //uuid
  uuid() {
    let temp_url = URL.createObjectURL(new Blob());
    let uuid = temp_url.toString();
    URL.revokeObjectURL(temp_url);
    return uuid.substring(uuid.lastIndexOf('/') + 1);
  },

  getScrollbarWidth() {
    let oDiv = document.createElement('div');
    oDiv.style.cssText =
      'position:absolute;box-sizing:content-box;width:100px;height:100px;overflow:hidden;';
    let noScroll = document.body.appendChild(oDiv).clientWidth;
    oDiv.style.overflowY = 'scroll';
    let scroll = oDiv.clientWidth;
    oDiv.remove();
    return noScroll - scroll;
  },

  get100hv() {
    let oDiv = document.createElement('div');
    oDiv.style.cssText = 'position:fixed;height:100vh';
    let height = document.body.appendChild(oDiv).clientHeight;
    oDiv.remove();
    return height;
  },
};
